<template id="flow-template">
  <div class="homeview-realtime-data">
    <div class="titleInfo"><div class="redDot scaleBlock"></div>Live  实时数据</div>
   <!-- <div class="enTitle">
      
   </div> -->
   <div class="p_box">
       <div class="p_oneInfo" v-for="(item,ind) in realtimeData" :key="ind">
           <div class="one">
              <p class="p_title">{{item.name}}</p>
              <div class="shu_line">
                <div :class="{'shu_bgsmall':num=='1','shu_bgspot':num=='.','shu_bg':(num!='.'&&num!='1')}" v-for="(num,index) in item.data" :key="index">
                <!-- <div :class="[(num=='1'||num=='.')?'shu_bgsmall':'shu_bg']" v-for="(num,index) in item.data" :key="index"> -->
                  <img :src="getImg(num)" alt="">
                  </div> 
           </div>
        </div>
           
       </div>
   </div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
 import { placeInfo } from '../../../../../../request/api';
export default {
  name: "HomeViewFlow",
  componentName: "HomeViewFlow",
  data() {
    return {
      placeInfoData:"",
      realtimeData: [
        {
          name:"X位移",
          data:[]
        },
        {
          name:"Y位移",
          data:[]
        },
        {
          name:"Z位移",
          data:[]
        },
        {
          name:"水平位移",
          data:[]
        },
        {
          name:"垂直位移",
          data:[]
        },
      ],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      resultx:[]
    };
  },
  created() {
    this.getPlaceInfo();
  },
  mounted() {
  },
  methods: {
    getPlaceInfo(){
      let _this=this;
      let params={}
      placeInfo(params).then(res=>{
          console.log("地质详情")
          console.log(res)
          if (res.code==0) {
           _this.placeInfoData = res.data;
           let datax = res.data.x+"";
           _this.realtimeData[0].data = datax.split("");
           let datay = res.data.y+"";
           _this.realtimeData[1].data = datay.split("");
           let dataz = res.data.z+"";
           _this.realtimeData[2].data = dataz.split("");
           let datah = res.data.hor+"";
           _this.realtimeData[3].data = datah.split("");
           let datav = res.data.ver+"";
           _this.realtimeData[4].data = datav.split("");
          }
        })
    },
    getImg(name){
      if(name=="."){
         return require(`../../../theme-default/src/img/spot0.png`)
      }else{
        return require(`../../../theme-default/src/img/${name}.png`)
      }
      
    }
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.colorblue{
    color: #00bdff;
}
.colorred{
    color: #fd4d4e;
}
.coloryellow{
    color: #fedb4e;
}
.titleInfo{
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    color: #2ac1ff; 
    padding-left: 40px;
    position: relative;
    margin-top:15px;
    .redDot{
      position: absolute;
      left:20px;
      top:4px;
      width:16px;
      height:16px;
      background: url("../../../theme-default/src/img/red_dot.png");
      // transition-duration: 5s;
      // animation: play 5s linear infinite;
    }
}
.enTitle{
  width: 100%;
  height: 11rem;
  background-image: linear-gradient(90deg, 
		rgba(9, 36, 75, 0.1) 0%, 
		rgba(17, 58, 116, 0.21) 26%,  
		rgba(17, 58, 116, 0.21) 76%, 
		rgba(9, 36, 75, 0.1) 100%);
}
.p_box{
    margin-top: 15px;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    flex-wrap: wrap;
    .p_oneInfo{
        width:50%;
      .one{
          width:125px;
          margin:0 auto;
      }
      
      .p_title{
         color: #d6f0ff;
         font-size: 14px; 
         margin-bottom: 2rem;
         text-align: center;
      }
      .shu_line{
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../../theme-default/src/img/p_bg.png");
        background-size: cover;
        width:15.6rem;
        height:9.8rem;
        margin:0 auto;
        .shu_bg{
            width:2.9rem;
            height:4.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width:100%;
              height:100%;
            }
        }
        .shu_bgsmall{
            width:0.8rem;
            height:5.1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width:100%;
              height:100%;
            }
        }
        .shu_bgspot{
            width:0.5rem;
            height:4.1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width:100%;
              height:100%;
            }
        }
      }
    }
}
</style>